module.exports = __webpack_public_path__ + "img/LATIN10_12.ce8325cd.jpg";